/*
Footer
*/

import React from "react";
import { Link } from "gatsby";

import NewsletterForm from "./indexpage/newsletter-form";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagramSquare,
} from "@fortawesome/free-brands-svg-icons";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

const Footer = ({
  footerLinks,
  newsletterformMsg,
  contactPhones,
  contactEmail,
}) => {
  return (
    <footer className="position-relative z-index-10 d-print-none">
      <div className="py-4 pt-5 bg-gray-200 text-muted">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
              <h6 className="text-uppercase text-dark mb-3">Ota yhteyttä</h6>
              <ul className="list-unstyled">
                {contactPhones.map(phone => (
                  <li key={phone}>{phone}</li>
                ))}
                <li>
                  <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                </li>
              </ul>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <a
                    id=""
                    href="https://www.facebook.com/gaiatravels"
                    target="_blank"
                    className=""
                  >
                    <FontAwesomeIcon
                      icon={faFacebookSquare}
                      fixedWidth
                      size="2x"
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    id=""
                    href="https://www.instagram.com/gaiatravels/"
                    target="_blank"
                    className=""
                  >
                    <FontAwesomeIcon
                      icon={faInstagramSquare}
                      fixedWidth
                      size="2x"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-4">
              <h6 className="text-uppercase text-dark mb-3">
                Ohjeita ja vinkkejä
              </h6>
              <ul className="list-unstyled">
                {footerLinks.map(item => {
                  if (item.type === "url") {
                    return (
                      <li key={item.name}>
                        <a
                          href={item.target_url}
                          target="_blank"
                          className="text-muted"
                        >
                          {item.name}
                          <FontAwesomeIcon
                            icon={faExternalLinkAlt}
                            size="xs"
                            className="ml-1"
                            fixedWidth
                          />
                        </a>
                      </li>
                    );
                  } else {
                    return (
                      <li key={item.name}>
                        <Link to={item.url} className="text-muted">
                          {item.name}
                        </Link>
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
            <div className="col-lg-5">
              <h6 className="text-uppercase text-dark mb-3">
                Huvilauutiset ja tarjoukset
              </h6>
              <p className="mb-2">{newsletterformMsg.substring(0, 110)}</p>
              <NewsletterForm />
            </div>
          </div>
        </div>
      </div>

      <div className="py-4 font-weight-light bg-gray-800 text-gray-300">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 text-center text-md-left">
              <p className="text-sm mb-md-0">
                Oy Gaia Travels Ltd | Y-1953417-6 | SMAL 36807 | KuVi
                7457/06MjMv | &copy; {new Date().getFullYear()} Gaia Travels
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
